<template>
  <div>
    <h1>聯絡資訊</h1>
    <el-button
      type="primary"
      @click="
        dialog = true;
        select = null;
      "
    >新增聯絡人</el-button>
    <el-table :data="profiles" style="width: 100%" stripe>
      <el-table-column prop="name" label="名稱" />
      <el-table-column prop="description" label="備註" />
      <el-table-column prop="address" label="地址" />
      <el-table-column prop="phone" label="電話" />
      <el-table-column prop="email" label="email" />
      <el-table-column label="動作">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="
              dialog = true;
              select = scope.row;
            "
          >編輯</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :visible.sync="dialog" append-to-body>
      <pform
        v-if="dialog"
        :profile_id="company_id"
        :profile_type="'company'"
        :profile="select"
        @onUpdate="onUpdate"
      />
    </el-dialog>
  </div>
</template>
<script>
import pform from './form.vue'
import { getProfiles } from '@/api/profile'
export default {
  components: { pform },
  props: ['company_id'],
  data() {
    return {
      dialog: false,
      profiles: [],
      select: null
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.profiles = await getProfiles({
        profile_type: 'company',
        profile_id: this.company_id
      })
    },
    onUpdate() {
      this.init()
      this.dialog = false
    }
  }
}
</script>
